import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { instance } from '@app/api/axios';
import { showToaster } from '@shared/ui/messages/useToaster';
import i18n from '@app/i18n';

export const fetchReferrals = createAsyncThunk(
  'referrals/fetchReferrals',
  async (_, { rejectWithValue }) => {
    try {
      const res = await instance.get('/referral/statistic');
      return res.data;
    } catch (err) {
      showToaster(
        'error',
        err?.response?.data?.message || i18n.t('request_error'),
      );
      return rejectWithValue(err.message);
    }
  },
);

export const fetchBalanceHistory = createAsyncThunk(
  'referrals/fetchBalanceHistory',
  async ({ count, start }, { rejectWithValue }) => {
    try {
      const res = await instance.get('/referral/balance-history', {
        params: { results: count, start },
      });
      return res.data;
    } catch (err) {
      showToaster(
        'error',
        err?.response?.data?.message || i18n.t('request_error'),
      );
      return rejectWithValue(err.message);
    }
  },
);

const referralsSlice = createSlice({
  name: 'referrals',
  initialState: {
    referrals: [],
    statistic: null,
    isLoading: true,
    balanceHistory: [],
    balanceHistoryCount: 0,
    isBalanceHistoryLoading: true,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferrals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReferrals.fulfilled, (state, action) => {
        const { referrals, ...statistic } = action.payload ?? {};
        state.referrals = referrals ?? [];
        state.statistic = statistic;
        state.isLoading = false;
      })
      .addCase(fetchReferrals.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(fetchBalanceHistory.pending, (state, action) => {
        if (action.meta.arg.start === 1) {
          state.balanceHistory = [];
        }
        state.isBalanceHistoryLoading = true;
      })
      .addCase(fetchBalanceHistory.fulfilled, (state, action) => {
        state.balanceHistory.push(...(action.payload?.payments ?? []));
        state.balanceHistoryCount = action.payload?.total ?? 0;
        state.isBalanceHistoryLoading = false;
      })
      .addCase(fetchBalanceHistory.rejected, (state) => {
        state.isBalanceHistoryLoading = false;
      });
  },
});

export default referralsSlice.reducer;
